import { render } from "./StandardScoreSettings.vue?vue&type=template&id=484dd24a&scoped=true"
import script from "./StandardScoreSettings.vue?vue&type=script&lang=js"
export * from "./StandardScoreSettings.vue?vue&type=script&lang=js"

import "./StandardScoreSettings.vue?vue&type=style&index=0&id=484dd24a&scoped=true&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-484dd24a"]])

export default __exports__